import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ContactShowRound, ContactShowRoundChanges, ContactShowRoundsResponse } from './contact-show-round.model';

/**
 * TVG-324: HTTP wrapper for a contact's show rounds. Rounds are booked on the
 * event; TVG-379 lets staff record who showed them round and the outcome here. Gated server-side on the `crm-sales-flow`
 * toggle (404 when off).
 */
@Injectable({
  providedIn: 'root',
})
export class ContactShowRoundService {
  private readonly apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  listForContact(contactId: number | string): Observable<ContactShowRoundsResponse> {
    return this.http.get<ContactShowRoundsResponse>(
      `${this.apiUrl}/api/contacts/${contactId}/show-rounds`,
    );
  }

  update(viewingId: number, changes: ContactShowRoundChanges): Observable<{ data: ContactShowRound }> {
    return this.http.patch<{ data: ContactShowRound }>(`${this.apiUrl}/api/event-viewings/${viewingId}`, changes);
  }
}
